import { ContactFormData } from '@upright/common/activities/contact-forms/facade/contact-form';
import { postContactForm } from '@upright/ui/api/activities/facade-contact-forms';
import { RequestStatus } from '@upright/ui/api/common/types';
import { useEffect, useState } from 'react';

// OA: Some old stuff copied over, rewrite when time.
export function usePostContactForm(): [(data: ContactFormData) => void, RequestStatus, () => void] {
  const [data, postData] = useState<ContactFormData | undefined>(undefined);
  const [status, setStatus] = useState<RequestStatus>(RequestStatus.INITIAL);

  function initialize() {
    postData(undefined);
    setStatus(RequestStatus.INITIAL);
  }

  useEffect(() => {
    const load = async () => {
      if (data) {
        setStatus(RequestStatus.LOADING);
        const result = await postContactForm(data);
        if (result.data) {
          setStatus(RequestStatus.SUCCESS);
        } else {
          setStatus(RequestStatus.ERROR);
        }
        if (result.apiError) {
          setStatus(RequestStatus.ERROR);
        }
      }
    };
    void load();
  }, [data]);

  return [postData, status, initialize];
}
